// import axios      from 'axios'
const { folder_logos, color_n , color, ext_bg , ext_mark} = require('@/helpers/js/logos.js');
class logos {
  constructor(url, ext = ``, axios){
    this.URL    = url;
    this.axios  = axios
    this.logoss = {
        'login'       : ext + '/img/' + folder_logos + '/LogoLogin.png',   // @/assets
        'login_night' : ext + '/img/' + folder_logos + '/LogoLoginNight.png', //@/assets
        'favicon'     : '',
        'logo_light'  : ext + '/img/' + folder_logos + '/Logo.png',
        'logo_night'  : ext + '/img/' + folder_logos + '/LogoNight.png',
        'background'  : ext + '/img/' + folder_logos + '/bg-grande.' + ext_bg,
        'no_signal'   : ext + '/img/no_signal.jpg',
        'no_img_found'    : ext + '/img/no_img_found.png',
        'mark'        : ext + '/img/' + folder_logos + '/mark.' + ext_mark,
        'color_login_n' : color_n,
        'color_login'   : color,
      }
  }
  default(){

    if (localStorage.getItem('logos')) {
      return JSON.parse(localStorage.getItem('logos'));
    }else{

     return this.logoss;
    }
  }

	get_logos(){
	 	let check_list    = [
 	    'login',
      'login_night',
      'favicon',
      'logo_light',
      'logo_night',
      'background'
    ];
    return null;
        /*const api    = this.URL + "/api/v1/imagesLogos";
        let logos_temp  = this.logoss;
        this.axios.get(api).then(res => {
          console.log("RES logo class", res )
          if (res && res.data) {
            let items = res.data;
            if (items.rows && items.rows.length > 0) {
              items.rows.forEach((img)=>{

                let name = img.name ? img.name.split('.')[0] : null;  
                console.log("logo NAME : ", name)
                if (name && check_list.indexOf(name)) {
                  logos_temp[name] = this.URL + img.url_path;
                  console.log("logo url : ",logos_temp[name])
                }
              }); // forEach
              localStorage.setItem('logos', JSON.stringify(logos_temp));
               
              return logos_temp;
            }

            
          }
        }).catch( er => {
          return null;
          console.log("Error get LOGOS : ", er);
        })*/
      } // get logos
}
export default logos;